// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jm0S5","left":"styles_left__3XuAL"};